import { defineStore } from "pinia";

export const useModalStore = defineStore('ModalStore', {
    state: () => {
        return {
            modalMailingDelete: { modalVisibility: false },
            modalSelectFromContacts: { modalVisibility: false },
            modalSelectFrequencyMailing: { modalVisibility: false }
        }
    },
    actions: {
        switchingVisibility(currentModal) {
            currentModal.modalVisibility = !currentModal.modalVisibility;
            currentModal.modalVisibility ?
                document.querySelector('body').classList.add('overflow_lock') :
                document.querySelector('body').classList.remove('overflow_lock');
        }
    }
});
